module.exports = __webpack_public_path__ + "static/media/01B.344d7bf8.png";